/**
 * 게시물 표의 «이름» 칸에 세울 작성자 표시명.
 *
 * ⚠️ 수집기가 플랫폼 API 의 오류 문구를 `author` 에 그대로 담아 둔 문서가 있다
 *   (Meta Graph API 「Access delayed. Only the owner of the page can access this information」).
 *   이름이 아니므로 표시에서는 빈 이름으로 본다 — 그러면 표는 @계정만 세운다. 문서는 고치지 않는다.
 */

/** 이름 자리에 들어와도 이름이 아닌 플랫폼 오류 문구(소문자 · 앞뒤 공백·마침표 무시) */
const PLATFORM_ERROR_AUTHOR_TEXTS = [
  'access delayed. only the owner of the page can access this information',
];

/**
 * @param author 원본 `author`
 * @returns 표시할 이름 — 오류 문구면 빈 문자열, 아니면 원문 그대로
 */
export function displayAuthorName(author: unknown): string {
  const raw = author == null ? '' : String(author);
  const key = raw.trim().replace(/\.+$/, '').replace(/^\(#\d+\)\s*/, '').toLowerCase();
  return PLATFORM_ERROR_AUTHOR_TEXTS.includes(key) ? '' : raw;
}
